import { Modal, Input, Form, Button, message, Cascader, Switch } from 'antd'
import { goodsCategorySave, goodsCategoryUpdateById } from '@/services/goods.ts'
import { useEffect, useMemo, useState } from 'react'
import { cloneDeep, isEmpty } from 'lodash-es'
import { deleteObjNodeById, trimStr } from '@/utils/data.ts'
import { addDataClose, dataCloseModify } from '@/services/customerServices'
import {SDrawerOrModal} from "shj-components";
const { TextArea } = Input
const CategoryModal = props => {
  const { open, onClose, fn, record } = props
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    console.log(record, 'record')
    form.resetFields()
    if (open && !isEmpty(record)) {
      const cateIdPath = record.cateIdPath?.split('>')
      const parentIdPath = cateIdPath?.slice(
        1,
        record.id ? cateIdPath.length - 1 : cateIdPath.length
      )

      form.setFieldsValue({ ...record, parentId: parentIdPath })
    }
  }, [open])

  const newTreeData = useMemo(() => {
    const data = cloneDeep(props.cateTreeList)
    if (record.id && !isEmpty(data)) {
      deleteObjNodeById(data, record.parentId, record.id)
    }
    return data
  }, [props.cateTreeList, record.id])

  const save = () => {
    form.validateFields().then(values => {
      setBtnLoading(true)
      const apiUrl = record.id ? dataCloseModify : addDataClose
      const parentId = values.parentId
        ? values.parentId[values.parentId.length - 1] || '0'
        : record.parentId
          ? record.parentId
          : '0'
      values.enabled = !!values.enabled
      apiUrl({ ...values, parentId })
        .then(res => {
          message.success(res?.message || '操作成功')
          onClose?.()
          fn?.()
        })
        .finally(() => setBtnLoading(false))
    })
  }

  return (
    <SDrawerOrModal
        // mode={'modal'}
      open={open}
      onCancel={onClose}
      width={500}
      title={record.id ? '编辑关闭原因' : '新增关闭原因'}
        loading={btnLoading}
        okText={'保存'}
        onOk={save}
    >
      <Form
        style={{ padding: '10px 0' }}
        form={form}
        layout={'vertical'}
        labelCol={{
          span: 6,
        }}
      >
        <Form.Item hidden name={'id'}>
          <Input />
        </Form.Item>
        <Form.Item
          name="parentId"
          label="父级分类"
          hidden={!record.id || record?.cateIdPath?.split('>').length === 2}
          rules={[
            {
              required: Boolean(record.id) && record?.cateIdPath?.split('>').length > 2,
              message: '父级分类不能为空',
            },
          ]}
        >
          <Cascader
            changeOnSelect
            expandTrigger={'hover'}
            displayRender={(labels: string[]) => labels[labels.length - 1]}
            options={newTreeData}
            fieldNames={{ value: 'id' }}
            placeholder={'请选择父级分类'}
          />
        </Form.Item>
        <Form.Item
          name="key"
          label="编码"
          rules={[
            {
              required: true,
              message: '编码不能为空',
            },
          ]}
        >
          <Input
            maxLength={20}
            showCount
            placeholder="请输入编码"
            onChange={(v: any): void => {
              form.setFieldValue('key', trimStr(v.target.value))
            }}
          />
        </Form.Item>
        <Form.Item
          name="name"
          label="名称"
          rules={[
            {
              required: true,
              message: '名称不能为空',
            },
          ]}
        >
          <Input
            maxLength={20}
            showCount
            placeholder="请输入名称"
            onChange={(v: any): void => {
              form.setFieldValue('name', trimStr(v.target.value))
            }}
          />
        </Form.Item>
        <Form.Item name="sortNumber" label="排序">
          <Input
            placeholder="请输入排序"
            onChange={(v: any): void => {
              form.setFieldValue('sortNumber', trimStr(v.target.value))
            }}
          />
        </Form.Item>
        <Form.Item name="enabled" label="是否启用">
          <Switch checkedChildren="启用" unCheckedChildren="禁用" />
        </Form.Item>
        <Form.Item name="description" label="描述">
          <TextArea
            maxLength={200}
            showCount
            placeholder="请输入"
            onChange={(v: any): void => {
              form.setFieldValue('description', trimStr(v.target.value))
            }}
          />
        </Form.Item>
      </Form>
    </SDrawerOrModal>
  )
}

export default CategoryModal
